export const addToFavoritesCategoryText = "aXa";
export default {addToFavoritesCategoryText};